// Mock data for fitness influencer portfolio

export const heroData = {
  headline: "Turn Fitness Content Into Revenue-Driving Brand Campaigns",
  subheadline: "Helping fitness brands across the USA generate high engagement, qualified traffic, and measurable conversions through performance-focused content.",
  stats: [
    { label: "Total Followers", value: "1.4M+" },
    { label: "Monthly Reach", value: "9.2M" },
    { label: "Avg Engagement Rate", value: "5.8%" },
    { label: "USA Audience", value: "72%" }
  ],
  ctaText: "Start a High-ROI Campaign",
  heroImage: "https://images.unsplash.com/photo-1646938863839-4d49ded55765"
};

export const brandPositioning = {
  headline: "More Than an Influencer — A Performance Partner for Fitness Brands",
  content: "I don't just create content. I build campaigns that drive action. Every post, story, and reel is strategically designed to align with your brand's goals—whether that's building awareness, driving traffic, or converting views into customers. With a highly engaged, fitness-focused audience across the USA, I help brands reach the right people at the right time with content that performs."
};

export const audienceInsights = {
  demographics: {
    title: "Demographics",
    items: [
      { label: "United States", value: "72%", flag: "🇺🇸" },
      { label: "Canada", value: "12%", flag: "🇨🇦" },
      { label: "United Kingdom", value: "8%", flag: "🇬🇧" },
      { label: "Australia", value: "5%", flag: "🇦🇺" },
      { label: "Other", value: "3%", flag: "🌍" }
    ]
  },
  ageGender: {
    title: "Age & Gender",
    items: [
      { label: "18-24", value: "28%" },
      { label: "25-34", value: "42%" },
      { label: "35-44", value: "20%" },
      { label: "45+", value: "10%" },
      { label: "Male", value: "58%" },
      { label: "Female", value: "42%" }
    ]
  },
  interests: {
    title: "Top Interests",
    items: [
      "Fitness & Training",
      "Nutrition & Supplements",
      "Athleisure & Activewear",
      "Wellness & Recovery",
      "Sports Performance"
    ]
  }
};

export const contentStrategy = {
  headline: "Content That Converts",
  description: "I create performance-driven content across multiple formats to maximize reach and engagement.",
  formats: [
    {
      title: "Instagram Reels",
      description: "High-energy, trending content optimized for maximum reach and shareability."
    },
    {
      title: "Story Series",
      description: "Behind-the-scenes, product demos, and interactive polls that drive engagement."
    },
    {
      title: "Feed Posts",
      description: "Polished, branded content with strategic CTAs and swipe-up links."
    },
    {
      title: "YouTube Videos",
      description: "Long-form reviews, tutorials, and brand storytelling for deeper connection."
    }
  ],
  image: "https://images.unsplash.com/photo-1758599879792-d6d5d4e3289c"
};

export const caseStudies = [
  {
    brand: "Premium Protein Co.",
    campaign: "Product Launch Campaign",
    results: [
      { metric: "Reach", value: "2.8M" },
      { metric: "Engagement Rate", value: "8.4%" },
      { metric: "Click-Through Rate", value: "4.2%" },
      { metric: "Conversions", value: "$47K" }
    ],
    description: "Multi-format campaign featuring product reviews, workout integrations, and exclusive discount codes.",
    image: "https://images.unsplash.com/photo-1599058917212-d750089bc07e"
  },
  {
    brand: "FitGear Apparel",
    campaign: "Summer Collection Launch",
    results: [
      { metric: "Reach", value: "1.9M" },
      { metric: "Engagement Rate", value: "7.1%" },
      { metric: "Click-Through Rate", value: "3.8%" },
      { metric: "ROI", value: "340%" }
    ],
    description: "Lifestyle content showcasing activewear in training sessions, with strategic product placement and authentic reviews.",
    image: "https://images.unsplash.com/photo-1762709753300-342ab94e8b05"
  },
  {
    brand: "Performance Supplements",
    campaign: "90-Day Transformation Series",
    results: [
      { metric: "Reach", value: "3.2M" },
      { metric: "Engagement Rate", value: "9.2%" },
      { metric: "Click-Through Rate", value: "5.1%" },
      { metric: "New Customers", value: "1,240" }
    ],
    description: "Long-term partnership featuring progress tracking, supplement integration, and educational content on performance nutrition.",
    image: "https://images.unsplash.com/photo-1770970716469-4b32abc0a577"
  }
];

export const collabOptions = [
  {
    title: "Sponsored Posts & Reels",
    description: "Dedicated branded content optimized for your campaign goals."
  },
  {
    title: "Product Reviews & Unboxings",
    description: "Authentic, detailed reviews that build trust and drive conversions."
  },
  {
    title: "Brand Ambassadorships",
    description: "Long-term partnerships with consistent, integrated content."
  },
  {
    title: "Affiliate Campaigns",
    description: "Performance-based partnerships with trackable ROI."
  },
  {
    title: "Event Coverage",
    description: "Live coverage and promotion of fitness events, launches, and activations."
  },
  {
    title: "UGC & Content Licensing",
    description: "High-quality content for your brand's own channels and advertising."
  }
];

export const finalCTA = {
  headline: "Let's Build Your Next High-Performing Campaign",
  description: "Whether you're launching a new product, building brand awareness, or driving direct sales, I create content that delivers measurable results. Let's discuss how we can work together to reach your fitness-focused audience with content that converts.",
  primaryCTA: "Request Collaboration Details",
  secondaryCTA: "Get Media Kit"
};

// Mock form submission
export const submitCollaborationForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted (MOCK):', formData);
      resolve({ success: true, message: 'Thank you! We\'ll get back to you within 24 hours.' });
    }, 1000);
  });
};
